export default "09981f43a2e9a678.svg"